// extracted by mini-css-extract-plugin
export var presentToPast = "header-module--presentToPast--2NN4G";
export var subtitle = "header-module--subtitle--GtvmB";
export var title = "header-module--title--oz1EK";